import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Ditigalgcc({ rtl }) {
  const className = rtl
    ? "tekrevol_gray_bg acc_section p-100 rtl-style"
    : "tekrevol_gray_bg acc_section p-100";
  return (
    <div className={className}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>
              عنق النجاح بالتعاون مع الشارقة طوير الجوال المملكة العربية
              السعودية
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              إنحن نقدم حلولاً رقمية مذهلة لمساعدة أعمالك على النجاح بفضل كوننا
              شركة دولية لتطوير تطبيقات الهاتف المحمول. باعتبارنا واحدة من أفضل
              شركات تصميم تطبيقات الهاتف المحمول في المملكة العربية السعودية،
              يمكننا مساعدتك في الارتقاء بأعمالك إلى آفاق جديدة بفضل خبرتنا في
              مجال التكنولوجيا في دول مجلس التعاون الخليجي والحلول الرقمية من
              الدرجة الأولى. باعتبارنا شركة رائدة في تصميم تطبيقات الهاتف
              المحمول، فإننا نقدم خدمات استشارية واسعة النطاق للمؤسسات، وسيقدم
              لك مصممو التطبيقات ذوو الخبرة في المملكة العربية السعودية الحلول
              الوظيفية التي تحتاجها لتحقيق أهدافك. وبفضل مساعدتنا، سيتمكن
              الموظفون من تحقيق التحول الرقمي الذي يحتاجونه لتحقيق النجاح.
            </p>
          </Col>
        </Row>
        <Row>
          <Accordion defaultActiveKey="">
            <Accordion.Item eventKey="0">
              <Accordion.Header>حلول مصممة خصيصًا للشركات</Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      إذا كنت تبحث عن تطوير تطبيقات الهاتف المحمول في الرياض
                      لتطوير حل مالي لعملك، فلا تبحث عنه، لأن هذا ما لا نستمتع
                      به. لفهم أفضل لما يمكننا تقديمه، راجع قائمة خدماتنا: تطوير
                      التطبيقات الأصلية لنظام اندرويد نحن نستخدم أحدث وأفضل
                      التقنيات لتطوير تطبيقات اندرويد الأصلية، بما في ذلك أطر
                      العمل الناشئة مثل Kotlin وJava والمزيد. تتميز حلولنا
                      بتكلفتها الاقتصادية وسهولة التكامل وقابلة للتوسع لتلبية
                      احتياجات العميل
                    </p>
                    <p>
                      يسعى مطورو التطبيقات لدينا في المملكة العربية السعودية
                      دائمًا إلى مواكبة أحدث الأدوات والأطر والتقنيات، التي
                      تساعد الشركات على تحويل تطبيقات أحلامها إلى حقيقة.
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      بناء تطبيق أندرويد
                    </Link>
                  </div>
                  <div className="acc_img">
                    <StaticImage
                      src="../../../images/locationgcc/sa/androidapp.webp"
                      alt="mobile app development company in dubai"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={470}
                      height={720}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                تطوير التطبيقات الأصلية لأنظمة آي أو إس
              </Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      تتميز خدماتنا لتطوير التطبيقات الأصلية لأنظمة آي أو إس
                      بقدرتها على التطوير والصيانة، كما أنها تعمل بسلاسة على
                      جميع أجهزة Apple مثل iPhone وiPad وApple Watch وApple.
                      يستخدم مطورونا ذوو الخبرة أحدث لغات البرمجة لتطوير تطبيقات
                      الهاتف المحمول مثل Swift وAlkainiyah بغرض إنشاء تطبيقات
                      سهلة الاستخدام تلتزم بمواصفات ABL. يستكشف خبراؤنا باستمرار
                      أحدث التقنيات والاتجاهات لضمان إنشاء منتجات سيحبها الجميع
                      باستخدام ممارسات تطوير التطبيقات لدينا. يتكون فريق تطوير
                      التطبيقات المختلطة في TekRevol من مصممي تجربة المستخدم
                      مهندسو تجربة المستخدم والبرمجيات المهرة والمبدعون الذين
                      يتمتعون بسجل حافل في بناء تطبيقات هجينة مستدامة وقابلة
                      للتطوير. نحن نمكّن الشركات الناشئة والمؤسسات من إنشاء
                      تطبيقات هجينة قوية تعمل بكامل طاقتها بسرعة عبر جميع منصات
                      تطبيقات الأجهزة المحمولة الرئيسية.
                    </p>
                    <p>
                      تتضمن حلول التطوير عبر الأنظمة الأساسية تصميم واجهة
                      المستخدم للتطبيق، والنماذج الأولية، والهندسة المعمارية،
                      وتكامل الطرف الثالث، وترحيل التطبيقات. وقد أثبت هذا النهج
                      الاستباقي أنه يؤدي إلى خفض تكاليف وجهود التسويق وزيادة
                      التساهل الشامل مع عملائنا من رجال الأعمال
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      إنشاء تطبيق iOS
                    </Link>
                  </div>
                  <div className="acc_img">
                    <StaticImage
                      src="../../../images/locationgcc/sa/iosapp.webp"
                      alt="mobile app development company in dubai"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={470}
                      height={720}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>تطوير تطبيقات الهاتف المحمول</Accordion.Header>
              <Accordion.Body>
                <div className="acc_content">
                  <div className="acc_txt">
                    <p>
                      تطوير تطبيقات الهاتف المحمول هو عملية إنشاء تطبيقات برمجية
                      مصممة خصيصًا للتشغيل على الأجهزة المحمولة مثل الهواتف
                      الذكية والأجهزة اللوحية. ويتضمن سلسلة من الخطوات، بما في
                      ذلك التفكير والتصميم والتطوير والاختبار والنشر. يستخدم
                      المطورون لغات وأطر برمجة مختلفة مصممة خصيصًا لمنصات محددة
                      مثل اندرويد أو آي أو إس لضمان التوافق والأداء.
                    </p>
                    <p>
                      عند تطوير تطبيقات الهاتف المحمول، يجب على المطورين مراعاة
                      عوامل مثل تجربة المستخدم وتوافق الجهاز والأمان طوال دورة
                      حياة التطوير. إنهم يستفيدون من الخدمات السحابية لتحسين
                      وظائف التطبيق ومواجهة التحديات المرتبطة بتطوير تطبيقات
                      الهاتف المحمول. يتطلب التطور المستمر لتكنولوجيا الهاتف
                      المحمول وتوقعات المستخدم البقاء على اطلاع بأحدث الاتجاهات
                      وأفضل الممارسات في تطوير تطبيقات الهاتف المحمول
                    </p>
                    <Link
                      to="/contact"
                      className="border_btn dark_btn"
                      aria-label="TekRevol Contact"
                    >
                      إنشاء تطبيق Hybird
                    </Link>
                  </div>
                  <div className="acc_img">
                    <StaticImage
                      src="../../../images/locationgcc/sa/hybridapp.webp"
                      alt="mobile app development company in dubai"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={470}
                      height={720}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>
      </Container>
    </div>
  );
}

export default Ditigalgcc;
